var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloatingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8182 7.5H19.7955V6.9C19.7955 3.09 16.7523 0 13 0C9.24773 0 6.20455 3.09 6.20455 6.9V7.5H1.18182C0.528126 7.5 0 8.03625 0 8.7V28.8C0 29.4637 0.528126 30 1.18182 30H10.8332C10.4867 29.1402 10.2306 28.2365 10.0762 27.3H2.65909V10.2H6.20455V13.5C6.20455 13.665 6.3375 13.8 6.5 13.8H8.56818C8.73068 13.8 8.86364 13.665 8.86364 13.5V10.2H17.1364V13.5C17.1364 13.5128 17.1372 13.5253 17.1387 13.5377C17.9761 13.1061 18.8655 12.7567 19.7955 12.5007V10.2H23.3409V12.0012C23.4018 12.0004 23.4627 12 23.5238 12C24.3694 12 25.197 12.0747 26 12.2177V8.7C26 8.03625 25.4719 7.5 24.8182 7.5ZM8.86364 6.9C8.86364 4.57875 10.7139 2.7 13 2.7C15.2861 2.7 17.1364 4.57875 17.1364 6.9V7.5H8.86364V6.9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCart);
export default __webpack_public_path__ + "static/media/floatingCart.c385a196ad3ea9b1ac703d4bcb88e87c.svg";
export { ForwardRef as ReactComponent };